<template>
  <div>
    <page-heading :title="$t(`${translationPrefix}.title`)"></page-heading>
    <el-row :gutter="20">
      <el-col :span="12">
        <timer></timer>
        <time-logs :date="today"></time-logs>
      </el-col>
      <el-col :span="12">
        <schedule title="Schedule" :userId="currentUser.id" />
        <el-card>
          <div slot="header">Upcoming PTOs</div>
          <ptos-list :ptos="approvedPtos"></ptos-list>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters, mapActions } from 'vuex';

  import PtosList from '@/components/pto/PtosList';
  import EfficiencyScore from '@/components/EfficiencyScore';
  import Schedule from '@/components/schedule/Schedule';
  import Timer from '@/components/Timer';
  import TimeLogs from '@/components/timeLog/TimeLogs';
  import CurrentClockedin from '@/components/CurrentClockedin';

  export default {
    name: 'DashboardPage',
    components: {
      timer: Timer,
      schedule: Schedule,
      efficiencyScore: EfficiencyScore,
      ptosList: PtosList,
      timeLogs: TimeLogs,
      currentClockedin: CurrentClockedin,
    },
    created() {
      this.fetchPtos();
      this.fetchApps();
    },
    data() {
      return {
        translationPrefix: 'pages.dashboard',
      };
    },
    computed: {
      ...mapGetters('entities/users', ['currentUser']),
      ...mapGetters('entities/ptos', ['fetching']),
      ...mapGetters('entities/apps', ['fetching']),

      apps() {
        return this.$store.getters['entities/apps/query']()
          .with('packages')
          .get();
      },
      today() {
        return moment();
      },
      startTime() {
        return moment().startOf('day');
      },
      endTime() {
        return moment().add(14, 'days').endOf('day');
      },
      approvedPtos() {
        return this.$store.getters['entities/ptos/query']()
          .with('user.profile')
          .with('category')
          .where(record => moment(record.starts_at).isBetween(this.startTime, this.endTime) && record.user_id === this.currentUser.id)
          .get();
      },
    },
    methods: {
      ...mapActions('entities/ptos', ['fetchPtos', 'openFormModal']),
      ...mapActions('entities/apps', ['fetchApps']),
    },
  };
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue